import BaseApi from '@core/api/model';

import { download } from '@utils/file';

export class MediaApi extends BaseApi {
    static resource = 'media';

    get endpoints() {
        return {
            ...super.endpoints,
            getUrl: this.getUrl.bind(this),
            download: this.download.bind(this)
        };
    }

    async getUrl(mediaId, fileId, action = 'inline') {
        if (!mediaId) {
            throw new Error('Media ID is required when trying to get URL');
        }

        if (!fileId) {
            throw new Error('File ID is required when trying to get URL');
        }

        if (!['inline', 'download'].includes(action)) {
            throw new Error('Invalid action. Expected "inline" or "download" when getting URL');
        }

        return (await BaseApi.api.get(`${this.base_url}/${mediaId}/file/${fileId}?action=${action}`)).data.url;
    }

    async download(id, type = 'file') {
        if (!id) {
            throw new Error('Media ID is required');
        }

        if (!['file', 'audit'].includes(type)) {
            throw new Error('Invalid type. Expected "file" or "audit"');
        }

        const media = (await BaseApi.api.get(`${this.base_url}/${id}`)).data;

        if (!media) {
            throw new Error(`No media found for ID ${id}`);
        }

        if (type === 'file' && media.external_url) {
            window.open(media.external_url, '_blank');
            return media;
        }

        const file = type === 'file' ? media.file : media.audit_file;

        if (!file) {
            throw new Error(`No ${type} file found for media ID ${id}`);
        }

        const fileUrl = await this.getUrl(id, file.id, 'download');

        download(fileUrl, true);

        return media;
    }
}

export default MediaApi;
